var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabor3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 410.78 236.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".labor-3-cls{fill:none;stroke:#367c2b;stroke-linecap:round;stroke-linejoin:round;stroke-width:10.78px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "labor-3-cls",
    cx: 172.45,
    cy: 113.19,
    r: 30.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "labor-3-cls",
    cx: 271.45,
    cy: 88.44,
    r: 30.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "labor-3-cls",
    d: "M240.51,230.75v-44a24.75,24.75,0,0,0-16.92-23.48l-20.2-6.74-30.94,30.94L141.51,156.5l-20.2,6.74a24.74,24.74,0,0,0-16.92,23.48v44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "labor-3-cls",
    d: "M339.51,206V162a24.75,24.75,0,0,0-16.92-23.48l-20.2-6.74-30.94,30.94-30.94-30.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "labor-3-cls",
    x1: 129.14,
    y1: 193.63,
    x2: 129.14,
    y2: 230.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "labor-3-cls",
    x1: 215.76,
    y1: 193.63,
    x2: 215.76,
    y2: 230.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "labor-3-cls",
    x1: 314.76,
    y1: 168.88,
    x2: 314.76,
    y2: 206
  }), /*#__PURE__*/React.createElement("line", {
    className: "labor-3-cls",
    x1: 30.14,
    y1: 168.88,
    x2: 30.14,
    y2: 206
  }), /*#__PURE__*/React.createElement("circle", {
    className: "labor-3-cls",
    cx: 73.45,
    cy: 88.44,
    r: 30.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "labor-3-cls",
    d: "M5.39,206V162a24.75,24.75,0,0,1,16.92-23.48l20.2-6.74,30.94,30.94,30.94-30.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "labor-3-cls",
    points: "357.35 5.39 357.35 85.46 333.32 85.46 369.36 141.51 405.39 85.46 381.37 85.46 381.37 5.39"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabor3);
export default __webpack_public_path__ + "static/media/labor_3.6c09b9169298c5a5b85b457bced64326.svg";
export { ForwardRef as ReactComponent };